module.exports = __webpack_public_path__ + "static/img/broadcast.15b65193.png";